export class House {
    static create_houses_map(raw_array){
        let ret = new Map()
        raw_array.forEach(house_raw => {
            let house = new House(house_raw)
            ret.set(house.get_id, house)
        })
        return ret
    }


    constructor(house_object) {
        let is_id_valid = ('id' in house_object && typeof(house_object.id) === "string")
        let is_name_valid = ('name' in house_object && typeof(house_object.name) === "string")
        let is_minlos_valid = ('minlos' in house_object && typeof(house_object.minlos) === "number")
        let are_rooms_present = ('rooms' in house_object && Array.isArray(house_object.rooms))
        let are_roomtypes_present = ('custom_room_types' in house_object && Array.isArray(house_object.custom_room_types))
        let is_invalid = [is_id_valid, is_name_valid, is_minlos_valid, are_rooms_present, are_roomtypes_present].reduce(concatWithOrNot, false)
        if (is_invalid) {
            throw "Room not valid: " + JSON.stringify(house_object)
        }
        house_object.rooms =  Room.create_room_map(house_object.rooms)
        house_object.custom_room_types =  RoomType.create_room_type_map(house_object.custom_room_types)
        Object.assign(this, house_object)
    }

    get get_id() {
        return this.id
    }

    get get_name() {
        return this.name
    }

    get get_minlos(){
        return this.minlos
    }

    get get_rooms_mapping(){
        return this.rooms
    }

    get get_roomtype_mapping(){
        return this.custom_room_types
    }
}

export class Room {
    static create_room_map(raw_array) {
        let ret = new Map()
        raw_array.forEach(room_raw => {
            let room = new Room(room_raw)
            ret.set(room.get_id, room)
        })
        return ret
    }

    constructor(room_object) {
        let is_id_valid = ('id' in room_object && typeof (room_object.id) === "string")
        let is_name_valid = ('name' in room_object && typeof (room_object.name) === "string")
        let is_custom_room_type_id_valid = ('custom_room_type_id' in room_object && typeof (room_object.custom_room_type_id) === "number")
        let is_house_id_valid = ('house_id' in room_object && typeof (room_object.house_id) === "string")
        let is_invalid = [is_id_valid, is_name_valid, is_custom_room_type_id_valid, is_house_id_valid].reduce(concatWithOrNot, false)
        if (is_invalid) {
            throw "Room not valid: " + JSON.stringify(room_object)
        }
        Object.assign(this, room_object)
    }

    get get_id() {
        return this.id
    }

    get get_name() {
        return this.name
    }

    get get_custom_room_type_id(){
        return this.custom_room_type_id
    }

    get get_house_id(){
        return this.house_id
    }
}

function concatWithOrNot(acc, cur){
    return acc || !cur;
}

export class enums {
    static get MinLosLevelColors(){
        
        let COLOR_LEVELS = {
            GLOBAL_HOUSE: "#23D996",
            HOUSE: "#FB54CA",
            ROOM_TYPE: "#FFAC24",
            ROOM: "#FFFFFF"
          };
        return COLOR_LEVELS
    }

    static get levelSelector(){
        let  levels= {
            ROOM: "room",
            CATEGORY: "category"
          };
        return levels
    }
}

export class RoomType {

    static create_room_type_map(raw_array){
        let ret = new Map()
        raw_array.forEach(room_type_raw => {
            let room_type = new RoomType(room_type_raw)
            ret.set(room_type.get_id, room_type)
        })
        return ret
    }

    constructor(room_type_object) {
        let is_id_valid = ('id' in room_type_object && typeof(room_type_object.id) === "number")
        let is_name_valid = ('name' in room_type_object && typeof(room_type_object.name) === "string")
        let is_abbreviation_valid = ('abbreviation' in room_type_object && typeof (room_type_object.abbreviation) === "string")
        let are_rooms_present = ('rooms' in room_type_object && Array.isArray(room_type_object.rooms))
        let is_invalid = [is_id_valid, is_name_valid, is_abbreviation_valid, are_rooms_present].reduce(concatWithOrNot, false)
        if (is_invalid) {
            throw "RoomType not valid: " + JSON.stringify(room_type_object)
        }
        room_type_object.rooms =  Room.create_room_map(room_type_object.rooms)
        Object.assign(this, room_type_object)
    }

    get get_id() {
        return this.id
    }

    get get_name() {
        return this.name
    }

    get get_abbreviation(){
        return this.abbreviation
    }

    get get_rooms_mapping(){
        return this.rooms
    }
}

export class LengthOfStay {

    constructor(los_object) {
        let is_client_id_valid = ('client_id' in los_object && typeof(los_object.client_id) === "number")
        let is_type_valid = ('type' in los_object && typeof(los_object.type) === "string")
        let is_minlos_valid = ('minlos' in los_object && typeof(los_object.minlos) === "number")

        let has_roomid_and_valid =('room_id' in los_object && typeof(los_object.room_id) === "string")
        let has_houseid_and_valid =('house_id' in los_object && typeof(los_object.house_id) === "string")
        let has_customroomtypeid_and_valid = ('custom_room_type_id' in los_object && typeof(los_object.custom_room_type_id) === "number")

        // using the ^-operator is more sensible as ONLY one of the option should exists (the exception is programmed explicitly below)
        // see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Bitwise_XOR for more details
        let has_one_of_the_required_level_references = has_roomid_and_valid ^ has_houseid_and_valid ^ has_customroomtypeid_and_valid
        if('house_id' in los_object && 'custom_room_type_id' in los_object) {
            has_one_of_the_required_level_references = has_houseid_and_valid && has_customroomtypeid_and_valid
        }

        let is_invalid = [is_client_id_valid, is_type_valid, is_minlos_valid, has_one_of_the_required_level_references].reduce(concatWithOrNot, false)
        if (is_invalid) {
            throw "Room not valid: " + JSON.stringify(los_object)
        }
        Object.assign(this, los_object)
    }

    get get_client_id() {
        return this.client_id
    }

    get get_type() {
        return this.type
    }

    get get_minlos(){
        return this.minlos
    }

}